import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../updObject';

const initialState = {
    token: null,
    userFullname: null,
    user: {},
    error: null,
    loading: false,
    loadingStatus: false,
    authRedirectPath: '/',
    viewPermissions: [],
    formatDate: null,
};

const authStartChecking = ( state, action ) => {
    return updateObject( state, { loadingStatus: true } );
};

const authStart = ( state, action ) => {
    return updateObject( state, { error: null, loading: true } );
};

const checkFail = (state, action) => {
    return updateObject( state, { loadingStatus: false });
};

const authSuccess = (state, action) => {
    return updateObject( state, { 
        token: action.token,
        user: action.user,
        userFullname: action.userFullname,
        error: null,
        loading: false,
        loadingStatus: false,
     } );
};

const authFail = (state, action) => {
    return updateObject( state, {
        error: action.error,
        loading: false
    });
};

const authLogout = (state, action) => {
    return updateObject(state, { token: null, user: null, userFullname: null });
};

const setAuthRedirectPath = (state, action) => {
    return updateObject(state, { authRedirectPath: action.path })
}

const setViewPerm = (state, action) => {
    return updateObject( state, { viewPermissions: action.viewPermissions, formatDate: action.formatDate });
};

const getViewPerm = (state, action) => {
    return updateObject( state, { viewPermissions: action.viewPermissions, formatDate: action.formatDate });
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.AUTH_START: return authStart(state, action);
        case actionTypes.AUTH_START_CHECKING: return authStartChecking(state, action);
        case actionTypes.AUTH_SUCCESS: return authSuccess(state, action);
        case actionTypes.AUTH_FAIL: return authFail(state, action);
        case actionTypes.AUTH_LOGOUT: return authLogout(state, action);
        case actionTypes.SET_AUTH_REDIRECT_PATH: return setAuthRedirectPath(state,action);
        case actionTypes.AUTH_CHECK_FAIL: return checkFail(state, action);
        case actionTypes.SET_PERMISSIONS: return setViewPerm(state, action);
        case actionTypes.GET_PERMISSIONS: return getViewPerm(state, action);
        default:
            return state;
    }
};

export default reducer;
